import React from "react";
import CreateMaterialForm from "./CreateMaterialForm";
import { createMaterialSizes } from "../../services/MaterialAPI";
import Modal from "../generic/Modal";

interface CreateMaterialSizeFormProps {
    onCloseModal: () => void;
}

const CreateMaterialSizeForm: React.FC<CreateMaterialSizeFormProps> = ({ onCloseModal }) => {
    const formatSuccessMessage = (results: any[]): string => {
        if (!results || results.length === 0) {
            return "";
        }

        const successList = results
            .map((result, idx) => `${idx + 1}. Material size: "${result.size}"`)
            .join("\n");

        return `✅ The following material sizes were created successfully:\n\n${successList}`;
    };

    return (
        <Modal onClose={onCloseModal}>
            <CreateMaterialForm
                title="Create Material Sizes"
                fieldName="Material Size"
                onSubmit={createMaterialSizes}
                formatSuccessMessage={formatSuccessMessage}
                onCloseModal={onCloseModal}
            />
        </Modal>
    );
};

export default CreateMaterialSizeForm;
